import { serverRequest } from "../../../utility/helpers/Axios/serverRequest"
import { formatDateTime } from "../../../utility/helpers/formatDate"
import { alertTypes } from "../../types/alert/types"

const fechaManiana = () => {
    const fecha = new Date()
    fecha.setDate(fecha.getDate() + 1)
    return formatDateTime(fecha, 'YMD', '-', false).trim()
}

export const AlertLoad = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: alertTypes.AlertLoad,
            payload: await serverRequest('alert', null, { filter: [`date||$lte||${fechaManiana()}`, `status||$eq||false`] })
        })
    }
}